export const field = {
  marginBottom: '5',
}

export const input = {
  px: '4',
  py: '2',
  backgroundColor: 'neutral.background',
  borderColor: 'neutral.border',
  borderStyle: 'solid',
  borderWidth: 'md',
  borderRadius: 'md',
  display: 'block',
  outline: 'none',
  width: '100%',
}
